"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2493],{

/***/ 77268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SchemaOrg; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* eslint-disable react/no-danger */ 

function SchemaOrg(param) {
    var canonical = param.canonical, definition = param.definition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(definition)
                }
            })
        ]
    });
}


/***/ }),

/***/ 24897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommentCounter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var bootstrap_icons_icons_chat_fill_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19077);
/* harmony import */ var bootstrap_icons_icons_chat_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31987);



function CommentCounter(param) {
    var count = param.count, _commented = param.commented, commented = _commented === void 0 ? false : _commented, _className = param.className, className = _className === void 0 ? "" : _className;
    var icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_chat_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "mr-1"
    });
    var color = "";
    if (commented) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_chat_fill_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: "mr-1"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center text-xs dark:text-white ".concat(color, " ").concat(className),
        children: [
            icon,
            count || ""
        ]
    });
}


/***/ }),

/***/ 83539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LikeCounter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var bootstrap_icons_icons_heart_fill_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73221);
/* harmony import */ var bootstrap_icons_icons_heart_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16422);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(370);




function LikeCounter(param) {
    var count = param.count, _liked = param.liked, liked = _liked === void 0 ? false : _liked, className = param.className, onClick = param.onClick;
    var icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_heart_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: "mr-1"
    });
    var color = "";
    if (liked) {
        icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_heart_fill_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            className: "mr-1"
        });
        color = "text-green-800 font-bold dark:text-green-500";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex items-center text-xs dark:text-white", color, className),
            children: [
                icon,
                count || ""
            ]
        })
    });
}


/***/ }),

/***/ 98778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./components/basic/Portal/index.tsx


function Portal(param) {
    var isOpen = param.isOpen, children = param.children;
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        ref.current = document.getElementById("portal");
    }, []);
    if (!isOpen || !ref.current) {
        return null;
    }
    return /*#__PURE__*/ (0,react_dom.createPortal)(children, ref.current);
}

;// CONCATENATED MODULE: ./components/basic/Modal/index.tsx




function Modal(param) {
    var children = param.children, isOpen = param.isOpen, closeModal = param.closeModal;
    var wrapperRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(param) {
            var target = param.target;
            if ((0,_instanceof/* default */.Z)(target, Node)) {
                var ref;
                if (wrapperRef === null || wrapperRef === void 0 ? void 0 : (ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.isSameNode(target)) {
                    closeModal();
                }
            }
        };
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            return document.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        wrapperRef,
        closeModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
        isOpen: isOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative z-50",
            "aria-labelledby": "modal-title",
            role: "dialog",
            "aria-modal": "true",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fixed inset-0 z-10 overflow-y-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0",
                        ref: wrapperRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-900 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg",
                            children: children
                        })
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 5357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(370);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74340);




function LinkButton(param) {
    var children = param.children, _color = param.color, color = _color === void 0 ? "primary" : _color, _size = param.size, size = _size === void 0 ? "base" : _size, className = param.className, href = param.href, target = param.target, onClick = param.onClick, rel = param.rel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: target,
            onClick: onClick,
            rel: rel,
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .buttonColor */ .uX[color], _Button__WEBPACK_IMPORTED_MODULE_2__/* .buttonSize */ .L8[size], "cursor-pointer font-bold rounded-lg focus:z-10 focus:ring-2", className),
            children: children
        })
    });
}


/***/ }),

/***/ 11226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MiniFooter; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6635);
/* harmony import */ var _lib_website_static_links__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22131);
/* harmony import */ var _elements_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6553);
/* harmony import */ var _elements_LinkButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5357);





function MiniFooter(param) {
    var user = param.user, _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "min-w-full flex flex-col lg:flex-row space-y-8 lg:space-y-0 justify-between p-8 px-3 lg:px-11 lg:py-6 bg-gray-50 dark:bg-gray-800 text-gray-800 dark:text-gray-300 text-sm",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-8 md:items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-gray-500",
                        children: [
                            "\xa9 2023 - ",
                            user.pseudoName
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: "".concat(_lib_website_static_links__WEBPACK_IMPORTED_MODULE_2__/* .links.privacy */ .O.privacy, "&utm_content=footer-policies-link"),
                        children: _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].confidentiality.name */ .Z.confidentiality.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: "".concat(_lib_website_static_links__WEBPACK_IMPORTED_MODULE_2__/* .links.cgu */ .O.cgu, "&utm_content=footer-cgu-link"),
                        children: _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].conditions.name */ .Z.conditions.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col md:justify-between md:flex-row space-y-4 md:space-y-0 md:space-x-8 md:items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "ml-0 lg:ml-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                href: _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].home.getUrl */ .Z.home.getUrl(),
                                className: "font-bold no-underline",
                                children: "Partager"
                            }),
                            " ",
                            "– \xc9crire et partager avec votre communaut\xe9"
                        ]
                    }),
                    !isLoggedIn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LinkButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            href: _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].login.getUrl */ .Z.login.getUrl(),
                            color: "alternative",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "whitespace-nowrap",
                                children: "Publier sur Partager"
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 82027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthenticatedNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6635);
/* harmony import */ var _basic_AvatarPartager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99465);
/* harmony import */ var _basic_GenericDropDown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95351);
/* harmony import */ var _Navigation_BackendNav_NavOption__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16825);






var links = [
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: 0
    }, _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dashboard */ .Z.dashboard),
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: 1
    }, _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].subscriptions */ .Z.subscriptions),
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: 2
    }, _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].editUser */ .Z.editUser),
    (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        id: 3
    }, _config_routes__WEBPACK_IMPORTED_MODULE_1__/* .actions.logout */ .N.logout), 
];
function AuthenticatedNav(param) {
    var username = param.username, email = param.email, provider_metadata = param.provider_metadata;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_GenericDropDown__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        buttonClassName: "text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 rounded-full items-center dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
        buttonNode: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_AvatarPartager__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            name: username,
            provider_metadata: provider_metadata,
            variant: "beam"
        }),
        emplacement: "bottom-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-white divide-y divide-gray-100 rounded shadow w-64 dark:bg-gray-700 dark:divide-gray-600",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-4 py-3 text-sm text-gray-900 dark:text-white flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mr-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_AvatarPartager__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                name: username,
                                provider_metadata: provider_metadata,
                                variant: "beam"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "truncate",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: username
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-500 font-medium truncate",
                                    children: email
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "py-1 text-sm text-gray-700 dark:text-gray-200 flex flex-col",
                    children: links.map(function(link) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Navigation_BackendNav_NavOption__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                getUrl: link.getUrl,
                                onClick: link.onClick,
                                className: "flex items-center gap-2 px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white",
                                children: [
                                    link.icon,
                                    link.name
                                ]
                            })
                        }, link.id);
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 25312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnauthenticatedNav; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var bootstrap_icons_icons_person_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97847);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6635);
/* harmony import */ var _elements_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6553);
/* harmony import */ var _elements_LinkButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5357);






var links = [
    _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].login */ .Z.login,
    _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].register */ .Z.register
];
function UnauthenticatedNav(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        href: _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].login.getUrl */ .Z.login.getUrl(),
                        className: "text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 rounded-full p-2.5 items-center dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_person_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "z-10 hidden bg-white divide-y divide-gray-100 rounded shadow w-44 dark:bg-gray-700 dark:divide-gray-600",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "py-1 text-sm text-gray-700 dark:text-gray-200",
                            children: links.map(function(link) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: link.getUrl(),
                                        className: "block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white",
                                        children: link.name
                                    })
                                }, link.getUrl());
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "hidden md:block",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "text-sm mr-4 font-bold no-underline hover:text-gray-500",
                        href: _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].login.getUrl */ .Z.login.getUrl(),
                        children: _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].login.name */ .Z.login.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_LinkButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        color: "alternative",
                        href: _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].register.getUrl */ .Z.register.getUrl(),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "S'inscrire"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 37844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PublicationStandardLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./components/modules/Footer/MiniFooter/index.tsx
var MiniFooter = __webpack_require__(11226);
// EXTERNAL MODULE: ./node_modules/@cloudinary/transformation-builder-sdk/actions/resize.js + 36 modules
var resize = __webpack_require__(12073);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./components/basic/AvatarPartager/index.tsx
var AvatarPartager = __webpack_require__(99465);
// EXTERNAL MODULE: ./components/elements/Heading/Heading3/index.tsx
var Heading3 = __webpack_require__(83739);
// EXTERNAL MODULE: ./components/elements/Link/index.tsx
var Link = __webpack_require__(6553);
// EXTERNAL MODULE: ./components/modules/Header/AuthenticatedNav/index.tsx
var AuthenticatedNav = __webpack_require__(82027);
// EXTERNAL MODULE: ./components/modules/Header/UnauthenticatedNav/index.tsx
var UnauthenticatedNav = __webpack_require__(25312);
;// CONCATENATED MODULE: ./components/modules/Header/PublicationHeader/index.tsx









function PublicationHeader(param) {
    var user = param.user, className = param.className, publication = param.publication;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classnames/* default */.Z)("fixed top-0 left-0 right-0 p-2 px-3 bg-white border lg:px-11 lg:py-6 dark:bg-gray-800 dark:border-gray-700 z-20", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row flex-grow overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                        href: routes/* default.publicationSlug.getUrl */.Z.publicationSlug.getUrl(publication.slug),
                        type: "no-underline",
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarPartager/* default */.Z, {
                                name: publication.title,
                                provider_metadata: (ref = publication.logo) === null || ref === void 0 ? void 0 : ref.provider_metadata,
                                square: true,
                                className: "mr-4 min-w-[40px]",
                                resizeParameters: (0,resize/* fill */.hl)().width(160).height(160)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading3/* default */.Z, {
                                className: "!my-auto truncate whitespace-nowrap lg:text-lg",
                                children: publication.title
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center justify-end",
                    children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthenticatedNav/* default */.Z, {
                        username: user.username,
                        email: user.email,
                        provider_metadata: (ref1 = user.avatar) === null || ref1 === void 0 ? void 0 : ref1.provider_metadata
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnauthenticatedNav/* default */.Z, {})
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/modules/Layout/StandardLayout/PublicationStandardLayout/index.tsx




function PublicationStandardLayout(param) {
    var publication = param.publication, children = param.children, user = param.user;
    var ref = (0,react.useSession)(), session = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicationHeader, {
                user: session === null || session === void 0 ? void 0 : session.user,
                publication: publication
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniFooter/* default */.Z, {
                user: user,
                isLoggedIn: !!(session === null || session === void 0 ? void 0 : session.jwt)
            })
        ]
    });
}


/***/ }),

/***/ 41250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostPreview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6635);
/* harmony import */ var _basic_AvatarPartager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99465);
/* harmony import */ var _elements_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6553);
/* harmony import */ var _elements_Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99730);





function PostPreview(param) {
    var post = param.post, publication = param.publication;
    var ref, ref1;
    var ref2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: _config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPost.getUrl */ .Z.getPost.getUrl(publication.slug, post.id),
        className: "flex flex-col sm:flex-row max-w-full p-4 sm:p-6 bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700 no-underline",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_AvatarPartager__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: (ref2 = (ref = post.seoCover) === null || ref === void 0 ? void 0 : ref.url) !== null && ref2 !== void 0 ? ref2 : (ref1 = post.cover) === null || ref1 === void 0 ? void 0 : ref1.url,
                name: post.seoTitle || post.title,
                size: 20,
                className: "mr-6",
                square: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex-auto w-40 mt-4 sm:mt-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "font-sans font-bold text-lg mb-2 text-ellipsis truncate w-full",
                        children: post.seoTitle || post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "frontend",
                        className: "!text-base mb-6 truncate w-full",
                        children: post.seoTitle || post.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-gray-500 text-sm truncate w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: "".concat("https://partager.io").concat(_config_routes__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getPost.getUrl */ .Z.getPost.getUrl(publication.slug, post.id))
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 79114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PostTeaser; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cloudinary_url_gen_actions_resize__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(12073);
/* harmony import */ var bootstrap_icons_icons_lock_fill_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18342);
/* harmony import */ var bootstrap_icons_icons_reply_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6635);
/* harmony import */ var _features_publication_components_PublicationPosts_PublicationPosts_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78532);
/* harmony import */ var _lib_helper_date_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23940);
/* harmony import */ var _lib_helper_post_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93367);
/* harmony import */ var _lib_hooks_likeHook__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16089);
/* harmony import */ var _basic_CommentCounter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24897);
/* harmony import */ var _basic_LikeCounter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83539);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74340);
/* harmony import */ var _elements_Heading_Heading3__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83739);
/* harmony import */ var _elements_Link__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6553);
/* harmony import */ var _elements_Paragraph__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99730);
/* harmony import */ var _ImageCloudinary__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43894);


















function PostTeaser(param) {
    var post = param.post, publication = param.publication, user = param.user, onClickShare = param.onClickShare, domain = param.domain;
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_lib_hooks_likeHook__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        postId: post.id,
        likesProp: post.actions
    }), 3), totalLikes = ref1[0], isLiked = ref1[1], onLikeClick = ref1[2];
    var relativePath = (0,_features_publication_components_PublicationPosts_PublicationPosts_service__WEBPACK_IMPORTED_MODULE_5__/* .getRelativePath */ .L)(domain, publication.slug, post.id);
    var _slug;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "flex flex-row p-4 lg:hover:bg-gray-50 lg:dark:hover:bg-gray-700 rounded-2xl",
        children: [
            ((ref = post.cover) === null || ref === void 0 ? void 0 : ref.provider_metadata) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                href: relativePath,
                className: "hidden md:block mr-8",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ImageCloudinary__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    className: "w-[168px] aspect-video",
                    provider_metadata: post.cover.provider_metadata,
                    resizeParameters: (0,_cloudinary_url_gen_actions_resize__WEBPACK_IMPORTED_MODULE_17__/* .fill */ .hl)().width(150).height(84)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full md:w-[100%]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        type: "alternative",
                        href: relativePath,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Heading_Heading3__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                variant: "frontend",
                                level: 1,
                                className: "!mt-0 !mb-2",
                                children: post.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Paragraph__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "frontend",
                                children: post.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-row text-gray-500 text-sm whitespace-nowrap mt-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                type: "alternative",
                                href: _config_routes__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getUser.getUrl */ .Z.getUser.getUrl((_slug = user.slug) !== null && _slug !== void 0 ? _slug : user.id),
                                className: "flex flex-row space-x-2 mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "font-bold text-gray-800 dark:text-white",
                                    children: user.pseudoName
                                })
                            }),
                            (0,_lib_helper_post_helper__WEBPACK_IMPORTED_MODULE_7__/* .isPostHasPaywall */ .D3)(post.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "md:inline-flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_lock_fill_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        className: "w-[15px] h-[15px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "hidden md:inline-flex",
                                    children: (0,_lib_helper_date_helper__WEBPACK_IMPORTED_MODULE_6__/* .formatDateRelative */ .Km)(post.createdAt)
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-row space-x-2 ml-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_LikeCounter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        count: totalLikes,
                                        liked: isLiked,
                                        onClick: function() {
                                            return onLikeClick();
                                        },
                                        className: "mr-2 mt-1"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_CommentCounter__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        count: post.totalComments || 0,
                                        className: "font-normal"
                                    }),
                                    onClickShare && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        color: "link",
                                        onClick: function() {
                                            return onClickShare(post.id);
                                        },
                                        className: "-scale-x-100 px-0 lg:px-0 py-0 lg:py-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_reply_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 64972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SocialSharing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/envelope.svg
var envelope = __webpack_require__(98560);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/facebook.svg
var facebook = __webpack_require__(70828);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/link-45deg.svg
var link_45deg = __webpack_require__(63165);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/twitter.svg
var twitter = __webpack_require__(95431);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
;// CONCATENATED MODULE: ./lib/helper/social-helper.ts

function objectToGetParams(object) {
    var params = Object.entries(object).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
        return value !== undefined && value !== null;
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value)));
    });
    return params.length > 0 ? "?".concat(params.join("&")) : "";
}
function openInTargetBlank(url) {
    window.open(url, "_blank", "noopener,noreferrer");
}
function facebookShare(url, quote) {
    return openInTargetBlank("https://www.facebook.com/sharer/sharer.php".concat(objectToGetParams({
        u: url,
        quote: quote
    })));
}
function emailShare(url, param) {
    var subject = param.subject, body = param.body, separator = param.separator;
    openInTargetBlank("mailto:".concat(objectToGetParams({
        subject: subject,
        body: body ? body + separator + url : url
    })));
}
function linkedinShare(url, param) {
    var title = param.title, summary = param.summary, source = param.source;
    openInTargetBlank("https://www.linkedin.com/sharing/share-offsite/".concat(objectToGetParams({
        url: url,
        mini: "true",
        title: title,
        summary: summary,
        source: source
    })));
}
function twitterShare(url, param) {
    var title = param.title, via = param.via, _hashtags = param.hashtags, hashtags = _hashtags === void 0 ? [] : _hashtags, _related = param.related, related = _related === void 0 ? [] : _related;
    openInTargetBlank("https://twitter.com/share".concat(objectToGetParams({
        url: url,
        text: title,
        via: via,
        hashtags: hashtags.length > 0 ? hashtags.join(",") : undefined,
        related: related.length > 0 ? related.join(",") : undefined
    })));
}
function whatsappShare(url, param) {
    var title = param.title, separator = param.separator;
    var isMobileOrTablet = /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
    openInTargetBlank("https://".concat(isMobileOrTablet ? "api" : "web", ".whatsapp.com/send").concat(objectToGetParams({
        text: title ? title + separator + url : url
    })));
}

// EXTERNAL MODULE: ./components/elements/Button/index.tsx
var Button = __webpack_require__(74340);
;// CONCATENATED MODULE: ./components/modules/SocialSharing/index.tsx









function SocialSharing(param) {
    var url = param.url, title = param.title, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classnames/* default */.Z)("flex flex-row justify-between w-full mt-8 p-4 dark:bg-gray-800 rounded-lg  md:py-2", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                size: "no-size",
                onClick: function() {
                    return (0,helper/* copyToClipboard */.vQ)(url);
                },
                color: "transparent",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 rounded-full p-4 items-center dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_45deg/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                size: "no-size",
                color: "transparent",
                onClick: function() {
                    return facebookShare(url, title);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 rounded-full p-4 items-center dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                size: "no-size",
                color: "transparent",
                onClick: function() {
                    return twitterShare(url, {
                        title: title
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 rounded-full p-4 items-center dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(twitter/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                size: "no-size",
                color: "transparent",
                onClick: function() {
                    return emailShare(url, {
                        subject: title
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex text-gray-900 hover:bg-gray-100 hover:text-blue-700 focus:ring-blue-700 focus:text-blue-700 rounded-full p-4 items-center dark:text-gray-100 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(envelope/* default */.Z, {
                        className: "block m-auto"
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 42995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SubscribeBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var bootstrap_icons_icons_reply_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6635);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(370);
/* harmony import */ var _lib_helper_date_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23940);
/* harmony import */ var _basic_CommentCounter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24897);
/* harmony import */ var _basic_LikeCounter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83539);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74340);
/* harmony import */ var _elements_Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6553);
/* harmony import */ var _SubscriberForm__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65773);










function SubscribeBanner(param) {
    var publication = param.publication, user = param.user, className = param.className, likeData = param.likeData, totalComments = param.totalComments, onShareClick = param.onShareClick, onCommentsClick = param.onCommentsClick;
    var showSocialButtons = likeData !== undefined && totalComments !== undefined && onShareClick !== undefined;
    var _slug;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)("bg-gray-50 dark:bg-gray-800", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-[768px] mx-auto flex flex-wrap justify-between py-12 px-4 md:px-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:w-2/3",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SubscriberForm__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        publication: publication,
                        className: "md:pb-0 md:m-0 m-auto",
                        isSubscribeBanner: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-8 md:mt-0",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col text-gray-500 text-sm whitespace-nowrap",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_Link__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    href: _config_routes__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUser.getUrl */ .Z.getUser.getUrl((_slug = user.slug) !== null && _slug !== void 0 ? _slug : user.id),
                                    className: "flex flex-row mr-4 no-underline",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: "par\xa0"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-bold text-gray-800 dark:text-white",
                                            children: user.pseudoName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        "Lanc\xe9 ",
                                        (0,_lib_helper_date_helper__WEBPACK_IMPORTED_MODULE_3__/* .formatDateRelative */ .Km)(publication.createdAt)
                                    ]
                                })
                            ]
                        }),
                        showSocialButtons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-row mt-4 space-x-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_LikeCounter__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    count: likeData === null || likeData === void 0 ? void 0 : likeData.total,
                                    liked: likeData === null || likeData === void 0 ? void 0 : likeData.liked,
                                    onClick: likeData === null || likeData === void 0 ? void 0 : likeData.onClick
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                    type: "button",
                                    color: "transparent",
                                    size: "no-size",
                                    onClick: onCommentsClick,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_basic_CommentCounter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        count: totalComments || 0
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: onShareClick,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(bootstrap_icons_icons_reply_svg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        className: "-scale-x-100"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 78403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ getComments; },
  "w": function() { return /* reexport */ postComment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./lib/request.ts
var request = __webpack_require__(87888);
;// CONCATENATED MODULE: ./features/comment/comment.service.ts




var urlPlural = "/comments";
function getComments(api, entityId, query) {
    return _getComments.apply(this, arguments);
}
function _getComments() {
    _getComments = (0,_async_to_generator/* default */.Z)(function(api, entityId, query) {
        var queryString, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    queryString = lib_default().stringify(query);
                    return [
                        4,
                        (0,request/* getAxiosAPI */.P$)("".concat(urlPlural, "/api::").concat(api, ":").concat(entityId, "/flat?").concat(queryString))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _getComments.apply(this, arguments);
}
function postComment(api, entityId, data, userToken) {
    return _postComment.apply(this, arguments);
}
function _postComment() {
    _postComment = (0,_async_to_generator/* default */.Z)(function(api, entityId, data, userToken) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)("".concat(urlPlural, "/api::").concat(api, ":").concat(entityId), data, userToken)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _postComment.apply(this, arguments);
}

;// CONCATENATED MODULE: ./features/comment/index.ts




/***/ }),

/***/ 91822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShareModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51859);
/* harmony import */ var _components_modules_PostPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41250);
/* harmony import */ var _components_modules_SocialSharing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64972);
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6635);





function ShareModal(param) {
    var post = param.post, publication = param.publication;
    var postUrl = "".concat("https://partager.io").concat(_config_routes__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getPost.getUrl */ .Z.getPost.getUrl(publication.slug, post.id));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "m-auto p-8 dark:bg-gray-900",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_Heading_Heading2__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                level: 1,
                className: "!mt-0",
                children: "Partager l'article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules_PostPreview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                post: post,
                publication: publication
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modules_SocialSharing__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                url: postUrl,
                title: post.seoTitle || post.title
            })
        ]
    });
}


/***/ }),

/***/ 78532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ getRelativePath; }
/* harmony export */ });
/* harmony import */ var _config_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6635);
/* harmony import */ var _lib_helper_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20878);


function getRelativePath(domain, publicationSlug, postId) {
    return (0,_lib_helper_helper__WEBPACK_IMPORTED_MODULE_1__/* .isMainDomain */ .Qp)(domain) ? _config_routes__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getPost.getUrl */ .Z.getPost.getUrl(publicationSlug, postId) : _config_routes__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getPostCustomDomain.getUrl */ .Z.getPostCustomDomain.getUrl(postId);
}


/***/ }),

/***/ 39591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XO": function() { return /* binding */ ErrorMessages; }
/* harmony export */ });
/* unused harmony exports PublicationErrorMessages, PostErrorMessages */
var ErrorMessages;
(function(ErrorMessages) {
    ErrorMessages["UNAUTHORIZED"] = "Vous devez \xeatre connect\xe9 pour acc\xe8der \xe0 cette page";
    ErrorMessages["MALFORMED_URL"] = "Votre url n'est pas bien form\xe9e";
    ErrorMessages["INTERNAL_ERROR"] = "Une erreur est survenue, veuillez ressayer plus tard";
})(ErrorMessages || (ErrorMessages = {}));
var PublicationErrorMessages;
(function(PublicationErrorMessages) {
    PublicationErrorMessages["NOT_FOUND"] = "Aucune publication n'a \xe9t\xe9 trouv\xe9e";
})(PublicationErrorMessages || (PublicationErrorMessages = {}));
var PostErrorMessages;
(function(PostErrorMessages) {
    PostErrorMessages["NOT_FOUND"] = "Aucun article n'a \xe9t\xe9 trouv\xe9";
})(PostErrorMessages || (PostErrorMessages = {}));


/***/ }),

/***/ 23940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EV": function() { return /* binding */ formatDateFull; },
/* harmony export */   "Km": function() { return /* binding */ formatDateRelative; },
/* harmony export */   "dC": function() { return /* binding */ getDateYear; },
/* harmony export */   "k5": function() { return /* binding */ getDateNow; },
/* harmony export */   "qj": function() { return /* binding */ formatDateTimeMed; }
/* harmony export */ });
/* unused harmony exports formatDateRelativeWithSeconds, formatDateMed */
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30120);

function formatDateRelative(date) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date).setLocale("fr").toRelative({
        unit: [
            "years",
            "quarters",
            "months",
            "weeks",
            "days",
            "hours",
            "minutes"
        ]
    });
}
function formatDateRelativeWithSeconds(date) {
    return DateTime.fromISO(date).setLocale("fr").toRelative();
}
function formatDateFull(date) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date).setLocale("fr").toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.DATE_FULL */ .ou.DATE_FULL);
}
function formatDateMed(date) {
    return DateTime.fromISO(date).setLocale("fr").toLocaleString(DateTime.DATE_MED);
}
function formatDateTimeMed(date) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date).setLocale("fr").toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.DATETIME_MED */ .ou.DATETIME_MED);
}
function getDateYear(date) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date).setLocale("fr").year.toString();
}
function getDateNow() {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now().toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.DATE_MED */ .ou.DATE_MED);
}


/***/ }),

/***/ 93367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D3": function() { return /* binding */ isPostHasPaywall; }
});

// UNUSED EXPORTS: commentsQuery, getPostServerSidePropsHelper

// EXTERNAL MODULE: ./components/Tiptap/Extensions/PaywallWrapper/ExtensionPaywallWrapper.ts + 4 modules
var ExtensionPaywallWrapper = __webpack_require__(71204);
// EXTERNAL MODULE: ./features/comment/index.ts + 1 modules
var comment = __webpack_require__(78403);
// EXTERNAL MODULE: ./features/post/index.ts + 1 modules
var post = __webpack_require__(1485);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
;// CONCATENATED MODULE: ./components/SchemaOrg/SchemaOrg.service.ts


function getWordsFromPhrase(text) {
    return text.split(" ").filter(function(word) {
        return word.length > 0;
    });
}
function getWordsFromTiptapNode(tiptapNode, currentWords) {
    if (!tiptapNode.content) {
        return currentWords;
    }
    return tiptapNode.content.reduce(function(accumulator, node) {
        if (node.type === "text" && node.text) {
            return _to_consumable_array(accumulator).concat(_to_consumable_array(getWordsFromPhrase(node.text)));
        }
        return getWordsFromTiptapNode(node, accumulator);
    }, currentWords);
}
function SchemaOrg_service_getRawTextFromTiptap(tiptapContentString) {
    if (!tiptapContentString || !isValidJSON(tiptapContentString)) {
        return "";
    }
    var tiptapObject = JSON.parse(tiptapContentString);
    var words = getWordsFromTiptapNode(tiptapObject, []);
    return words.join(" ");
}
function getFullUrl(param, url) {
    var headers = param.headers;
    return "".concat(headers["x-forwarded-proto"] || "http", "://").concat(headers.host).concat(url);
}

// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var config_routes = __webpack_require__(6635);
;// CONCATENATED MODULE: ./features/post/schema.ts



var APP_URL = (/* unused pure expression or super */ null && ("https://partager.io"));
/**
 * Constants
 */ var authorJobTitle = "Auteur chez Partager";
var partagerOrganisation = {
    "@type": "Organization",
    name: "Partager",
    sameAs: [
        "https://www.facebook.com/Partager.io",
        "https://www.linkedin.com/company/partager-io", 
    ]
};
function schema_getBlogPostingSchema(post) {
    var ref, ref1, ref2;
    var postWords = getRawTextFromTiptap(post.text);
    var _slug;
    var schemaOrgDefinition = {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        url: "".concat(APP_URL).concat(routes.getPost.getUrl(post.publication.slug, post.id)),
        mainEntityOfPage: "".concat(APP_URL).concat(routes.getPost.getUrl(post.publication.slug, post.id)),
        headline: post.title,
        description: post.subtitle,
        isAccessibleForFree: !post.isPaid,
        wordcount: "".concat(post.wordsCount),
        dateCreated: post.createdAt.split("T")[0],
        articleBody: postWords,
        image: [],
        author: [
            {
                "@type": "Person",
                name: post.user.pseudoName,
                url: "".concat(APP_URL).concat(routes.getUser.getUrl((_slug = post.user.slug) !== null && _slug !== void 0 ? _slug : post.user.id)),
                jobTitle: authorJobTitle,
                memberOf: partagerOrganisation,
                description: getRawTextFromTiptap(post.user.biography),
                identifier: "user:".concat(post.user.id),
                image: [
                    {
                        "@type": "ImageObject",
                        url: ((ref = post.user.avatar) === null || ref === void 0 ? void 0 : ref.url) || ""
                    }, 
                ]
            }, 
        ],
        publisher: {
            "@type": "Organization",
            name: post.publication.title,
            url: routes.publication.getUrl(post.publication.slug),
            description: post.publication.description,
            identifier: "pub:".concat(post.publication.id)
        }
    };
    // Add alternative headline if exists
    if (post.seoTitle !== null) {
        schemaOrgDefinition.alternativeHeadline = post.seoTitle;
    }
    if (typeof ((ref1 = post.seoCover) === null || ref1 === void 0 ? void 0 : ref1.url) !== "undefined") {
        var ref3;
        schemaOrgDefinition.image.push({
            "@type": "ImageObject",
            url: (ref3 = post.seoCover) === null || ref3 === void 0 ? void 0 : ref3.url
        });
    }
    if (typeof ((ref2 = post.cover) === null || ref2 === void 0 ? void 0 : ref2.url) !== "undefined") {
        var ref4;
        schemaOrgDefinition.image.push({
            "@type": "ImageObject",
            url: (ref4 = post.cover) === null || ref4 === void 0 ? void 0 : ref4.url
        });
    }
    if (typeof post.publishedAt !== "undefined" && post.publishedAt !== null) {
        var ref5 = _sliced_to_array(post.publishedAt.split("T"), 1), datePublished = ref5[0];
        schemaOrgDefinition.datePublished = datePublished;
    }
    if (typeof post.updatedAt !== "undefined" && post.updatedAt !== null) {
        var ref6 = _sliced_to_array(post.updatedAt.split("T"), 1), dateModified = ref6[0];
        schemaOrgDefinition.dateModified = dateModified;
    }
    return schemaOrgDefinition;
}

// EXTERNAL MODULE: ./lib/errorMessages.ts
var errorMessages = __webpack_require__(39591);
;// CONCATENATED MODULE: ./lib/page-helper.ts

function goTo(destination) {
    return {
        redirect: {
            permanent: false,
            destination: destination
        }
    };
}
function goToLogin(errorMessage) {
    return goTo(routes.login.getUrl(errorMessage));
}
function page_helper_goToHomePage(errorMessage) {
    return goTo(routes.home.getUrl(errorMessage));
}
function goToProfile(slugOrId) {
    return goTo(routes.getUser.getUrl(slugOrId));
}
function goToDashboard() {
    return goTo(routes.dashboard.getUrl());
}
function goToPage500() {
    return goTo(routes.page500.getUrl());
}

;// CONCATENATED MODULE: ./lib/helper/post-helper.ts










// TODO: Populating fields seems not to work with comments, investigate why
function commentsQuery(page, pageSize) {
    return {
        filters: {
            blocked: {
                $not: true
            }
        },
        sort: "createdAt:desc",
        pagination: {
            page: page,
            pageSize: pageSize,
            withCount: true
        }
    };
}
function getPostServerSidePropsHelper(_) {
    return _getPostServerSidePropsHelper.apply(this, arguments);
}
function _getPostServerSidePropsHelper() {
    _getPostServerSidePropsHelper = _async_to_generator(function(param) {
        var postId, canonicalUrl, publicationSlug, userToken, domain, query, ref, post, coregPostsQuery, ref1, coregPosts, ref2, comments, commentsMeta, schemaOrgDefinition;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    postId = param.postId, canonicalUrl = param.canonicalUrl, publicationSlug = param.publicationSlug, userToken = param.userToken, domain = param.domain;
                    query = {
                        fields: [
                            "id",
                            "title",
                            "subtitle",
                            "text",
                            "isPaid",
                            "seoTitle",
                            "seoSubtitle",
                            "publishedAt",
                            "updatedAt",
                            "createdAt",
                            "readingTime",
                            "wordsCount",
                            "hideCover"
                        ],
                        populate: {
                            user: {
                                fields: [
                                    "id",
                                    "pseudoName",
                                    "slug",
                                    "biography"
                                ],
                                populate: {
                                    avatar: {
                                        fields: [
                                            "url"
                                        ]
                                    }
                                }
                            },
                            publication: {
                                fields: [
                                    "id",
                                    "title",
                                    "description",
                                    "thematic",
                                    "slug",
                                    "createdAt",
                                    "isPaid"
                                ],
                                populate: {
                                    subscriberLists: {
                                        fields: [
                                            "id",
                                            "enable",
                                            "sourceCode",
                                            "polarisId",
                                            "externalId",
                                            "price"
                                        ],
                                        populate: {
                                            offerType: {
                                                fields: [
                                                    "name"
                                                ]
                                            }
                                        }
                                    },
                                    logo: {
                                        fields: [
                                            "url",
                                            "provider_metadata"
                                        ]
                                    }
                                }
                            },
                            cover: {
                                fields: [
                                    "url",
                                    "provider_metadata"
                                ]
                            },
                            seoCover: {
                                fields: [
                                    "url"
                                ]
                            },
                            audio: {
                                fields: [
                                    "url"
                                ]
                            }
                        }
                    };
                    return [
                        4,
                        getPost(parseInt(postId, 10), query, userToken)
                    ];
                case 1:
                    ref = _state.sent(), post = ref.data;
                    if (publicationSlug) {
                        if (![
                            post.publication.slug.toLowerCase(),
                            post.publication.id.toString()
                        ].includes(publicationSlug)) {
                            return [
                                2,
                                goToHomePage(ErrorMessages.MALFORMED_URL)
                            ];
                        }
                    }
                    coregPostsQuery = _object_spread_props(_object_spread({}, query), {
                        filters: {
                            id: {
                                $ne: post.id
                            },
                            publication: {
                                id: post.publication.id
                            }
                        },
                        pagination: {
                            page: 1,
                            pageSize: 2
                        }
                    });
                    return [
                        4,
                        getPosts(coregPostsQuery)
                    ];
                case 2:
                    ref1 = _state.sent(), coregPosts = ref1.data;
                    return [
                        4,
                        getComments("post.post", post.id, commentsQuery(1, 3))
                    ];
                case 3:
                    ref2 = _state.sent(), comments = ref2.data, commentsMeta = ref2.meta;
                    schemaOrgDefinition = getBlogPostingSchema(post);
                    return [
                        2,
                        {
                            props: {
                                post: post,
                                coregPosts: coregPosts,
                                lastComments: comments,
                                totalComments: commentsMeta.pagination.total,
                                schemaOrgDefinition: schemaOrgDefinition,
                                canonicalUrl: canonicalUrl,
                                domain: domain
                            }
                        }
                    ];
            }
        });
    });
    return _getPostServerSidePropsHelper.apply(this, arguments);
}
function isPostHasPaywall(textString) {
    try {
        var textObject = JSON.parse(textString);
        if (!Array.isArray(textObject.content)) {
            return false;
        }
        return textObject.content.some(function(node) {
            return node.type === ExtensionPaywallWrapper/* PaywallName */.qd;
        });
    } catch (error) {
        return false;
    }
}


/***/ }),

/***/ 16089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useLike; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./lib/request.ts
var request = __webpack_require__(87888);
;// CONCATENATED MODULE: ./features/action/action.service.ts




var urlPlural = "/actions";
function getActions(queryObject) {
    return _getActions.apply(this, arguments);
}
function _getActions() {
    _getActions = (0,_async_to_generator/* default */.Z)(function(queryObject) {
        var queryString, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    queryString = lib_default().stringify(queryObject);
                    return [
                        4,
                        (0,request/* getAxiosAPI */.P$)("".concat(urlPlural, "?").concat(queryString))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _getActions.apply(this, arguments);
}
function createAction(data, userToken) {
    return _createAction.apply(this, arguments);
}
function _createAction() {
    _createAction = (0,_async_to_generator/* default */.Z)(function(data, userToken) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)("".concat(urlPlural), data, userToken)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _createAction.apply(this, arguments);
}
function deleteAction(actionId) {
    return _deleteAction.apply(this, arguments);
}
function _deleteAction() {
    _deleteAction = (0,_async_to_generator/* default */.Z)(function(actionId) {
        var response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,request/* deleteAxiosAPI */.zs)("".concat(urlPlural, "/").concat(actionId))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _deleteAction.apply(this, arguments);
}

;// CONCATENATED MODULE: ./features/action/action.interface.ts
var IActionType;
(function(IActionType) {
    IActionType["Like"] = "like";
})(IActionType || (IActionType = {}));

;// CONCATENATED MODULE: ./features/action/index.ts



;// CONCATENATED MODULE: ./lib/hooks/likeHook.ts






function getTotalLikes(postId, setLikesCounter) {
    return _getTotalLikes.apply(this, arguments);
}
function _getTotalLikes() {
    _getTotalLikes = (0,_async_to_generator/* default */.Z)(function(postId, setLikesCounter) {
        var query, ref, _meta, total, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = {
                        filters: {
                            post: postId,
                            type: IActionType.Like
                        },
                        fields: [
                            "id"
                        ],
                        populate: {
                            post: {
                                fields: [
                                    "title"
                                ]
                            }
                        },
                        pagination: {
                            start: 0,
                            limit: 1,
                            withCount: true
                        }
                    };
                    return [
                        4,
                        getActions(query)
                    ];
                case 1:
                    ref = _state.sent(), _meta = ref.meta, total = _meta.pagination.total;
                    setLikesCounter(total);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getTotalLikes.apply(this, arguments);
}
function getLikes(postId, visitorToken, setLikes) {
    return _getLikes.apply(this, arguments);
}
function _getLikes() {
    _getLikes = (0,_async_to_generator/* default */.Z)(function(postId, visitorToken, setLikes) {
        var query, ref, likes, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = {
                        filters: {
                            post: postId,
                            type: IActionType.Like,
                            visitorToken: visitorToken
                        },
                        fields: [
                            "visitorToken"
                        ],
                        populate: {
                            post: {
                                fields: [
                                    "title"
                                ]
                            }
                        }
                    };
                    return [
                        4,
                        getActions(query)
                    ];
                case 1:
                    ref = _state.sent(), likes = ref.data;
                    setLikes(likes);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _getLikes.apply(this, arguments);
}
function likeAction(postId, visitorToken, setLikes, cancel) {
    return _likeAction.apply(this, arguments);
}
function _likeAction() {
    _likeAction = (0,_async_to_generator/* default */.Z)(function(postId, visitorToken, setLikes, cancel) {
        var dataNewLike, ref, addedLike, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    dataNewLike = {
                        data: {
                            post: postId,
                            type: "like",
                            visitorToken: visitorToken
                        }
                    };
                    return [
                        4,
                        createAction(dataNewLike, "")
                    ];
                case 1:
                    ref = _state.sent(), addedLike = ref.data;
                    // add new created action to likes(actions) array manually instead of running a query to fetch new actions array
                    setLikes(function(oldLikes) {
                        oldLikes.push(addedLike);
                        return oldLikes;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error);
                    cancel();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _likeAction.apply(this, arguments);
}
function dislikeAction(actionId, likeIndex, setLikes, cancel) {
    return _dislikeAction.apply(this, arguments);
}
function _dislikeAction() {
    _dislikeAction = (0,_async_to_generator/* default */.Z)(function(actionId, likeIndex, setLikes, cancel) {
        var error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        deleteAction(actionId)
                    ];
                case 1:
                    _state.sent();
                    // delete the action manually from the likes(actions) array instead of running a query to fetch new actions array
                    setLikes(function(oldLikes) {
                        oldLikes.splice(likeIndex, 1);
                        return oldLikes;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.error(error);
                    cancel();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _dislikeAction.apply(this, arguments);
}
function useLike(param) {
    var postId = param.postId, likesProp = param.likesProp;
    var onLikeClick = function onLikeClick() {
        var currentStatus = likeStatus;
        var currentCounter = likesCounter;
        function cancel() {
            setLikeStatus(currentStatus);
            setLikesCounter(currentCounter);
        }
        if (likeStatus) {
            var likeIndex = likes.findIndex(function(like) {
                return like.visitorToken === cookies.visitorToken;
            });
            if (likeIndex > -1) {
                setLikeStatus(!currentStatus);
                setLikesCounter(currentCounter - 1);
                dislikeAction(likes[likeIndex].id, likeIndex, setLikes, cancel);
            }
        } else {
            setLikeStatus(!currentStatus);
            setLikesCounter(currentCounter + 1);
            likeAction(postId, cookies.visitorToken, setLikes, cancel);
        }
    };
    var ref = (0,react.useState)(likesProp || []), likes = ref[0], setLikes = ref[1];
    var ref1 = (0,react.useState)(0), likesCounter = ref1[0], setLikesCounter = ref1[1];
    var ref2 = (0,react.useState)(false), likeStatus = ref2[0], setLikeStatus = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)(), 1), cookies = ref3[0];
    (0,react.useEffect)(function() {
        if (likesProp) {
            setLikesCounter(likesProp.length);
            setLikes(likesProp);
        } else {
            getTotalLikes(postId, setLikesCounter);
            getLikes(postId, cookies.visitorToken, setLikes);
        }
    }, [
        postId,
        likesProp,
        cookies.visitorToken
    ]);
    (0,react.useEffect)(function() {
        var index = likes.findIndex(function(like) {
            return like.visitorToken === cookies.visitorToken;
        });
        setLikeStatus(index > -1);
    }, [
        likes,
        cookies
    ]);
    return [
        likesCounter,
        likeStatus,
        onLikeClick
    ];
}


/***/ }),

/***/ 22131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ links; },
/* harmony export */   "b": function() { return /* binding */ UTM_SOURCE; }
/* harmony export */ });
var UTM_SOURCE = "https://partager.io".replace("http://", "").replace("https://", "");
var URL = "https://a-propos.partager.io";
var links = {
    about: "".concat(URL, "/qui-sommes-nous?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    jobs: "".concat(URL, "/nous-recrutons?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    contact: "".concat(URL, "/contact?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    faq: "".concat(URL, "/faq?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    features: "".concat(URL, "/fonctions?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    prices: "".concat(URL, "/tarifs?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    partagerVSsubstack: "".concat(URL, "/partager-vs-substack?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    partagerVSkessel: "".concat(URL, "/partager-vs-kessel?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    partagerVSmailchimpVSsendinblue: "".concat(URL, "/partager-vs-mailchimp-vs-sendinblue?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    mentionsLegal: "".concat(URL, "/mentions-legales?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    privacy: "".concat(URL, "/politique-de-confidentialite?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    cgs: "".concat(URL, "/cgs?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    cgu: "".concat(URL, "/cgu?utm_source=").concat(UTM_SOURCE, "&utm_medium=web"),
    cookiesPolicy: "".concat(URL, "/politique-cookies?utm_source=").concat(UTM_SOURCE, "&utm_medium=web")
};


/***/ })

}]);